/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { RouteProtection } from '@/data/containers/manifest';
import { TranslationTable } from 'integration/generated/translations';
import { Layout } from '@/data/types/Layout';
import { User } from '@/data/User';
import { getElementsLandingsPage } from './ElementsLandingsPage';
import { getHelpCenterPage } from './HelpCenterPage';
import { getPlpPage } from '@/data/containers/PlpPage';
import { IncomingContent } from '@/data/types/IncomingContent';
import { getReturnsPage } from './ReturnsPage';
import { getRedirectSessionPage } from './RedirectSessionPage';

const layoutManifest = {
	ElementsLandingsPage: getElementsLandingsPage,
	HelpCenterPage: getHelpCenterPage,
	SubCategoryPageContainer: getPlpPage, // TODO: PLP CustomLayout - ContainerName
	DefaultCategoryPageLayout: getPlpPage, // TODO: PLP CustomLayout - Name
	ReturnsPage: getReturnsPage,
	RedirectSessionPage: getRedirectSessionPage,
};

export const dataContainerManifestCustom: {
	[key: string]: (props: IncomingContent) => Layout;
} = layoutManifest;

type LayoutKeys = keyof typeof layoutManifest;
type LocalRoutes = TranslationTable['Routes'];

/**
 * Layout relationships with translation route name as the key and
 * the layoutManifest key as the value.
 */
export const dataRouteManifestCustom: Record<string, LayoutKeys> = {
	ElementsLandings: 'ElementsLandingsPage',
	HelpCenter: 'HelpCenterPage',
	Returns: 'ReturnsPage',
	RedirectSession: 'RedirectSessionPage',
};

/**
 * Map of routes that are dependent on the user status for conditional
 * redirection or other protection. The method return dictates the
 * behavior:
 * 	- true: allow access
 * 	- false: do not load the route
 * 	- string: redirect to the route named in the string
 */
export const dataRouteProtectionCustom: Partial<
	Record<keyof LocalRoutes, (user: Partial<User>) => RouteProtection>
> = {};
